import type { JiraAlignProject } from '../../types';

export const isJiraAlignProject = (entity: any): entity is JiraAlignProject =>
	entity.__typename === 'JiraAlignAggProject';

export const getJiraAlignProjectLink = (project: JiraAlignProject): string | null =>
	project?.mercuryProjectUrl ?? null;
